var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReopen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3919_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.304038 4.0815C0.618067 3.87166 1.04285 3.95611 1.25269 4.27018L2.50949 6.15102C2.80938 5.15545 3.35213 4.24323 4.1079 3.48741C6.59628 0.998987 10.6453 0.998987 13.1337 3.48741C15.6221 5.97584 15.6221 10.0247 13.1337 12.5131C11.8895 13.7573 10.2551 14.3794 8.6208 14.3794C6.98646 14.3794 5.35211 13.7573 4.1079 12.5131C3.84079 12.246 3.84079 11.813 4.1079 11.5459C4.37501 11.2788 4.80805 11.2788 5.07516 11.5458C7.03023 13.5009 10.2114 13.5009 12.1664 11.5459C14.1215 9.59079 14.1215 6.4097 12.1664 4.45467C10.2113 2.49959 7.03018 2.49964 5.07516 4.45462C4.47168 5.05819 4.04124 5.78875 3.80814 6.58598L5.89285 5.19307C6.20693 4.98328 6.63166 5.06772 6.84155 5.3818C7.05143 5.69587 6.96694 6.12061 6.65282 6.33049L3.30256 8.569C3.18583 8.64697 3.05378 8.68432 2.92319 8.68432C2.70246 8.68432 2.48573 8.57762 2.35386 8.38027L0.115313 5.03015C-0.0945263 4.71612 -0.0100355 4.29138 0.304038 4.0815Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3919_1534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentcolor",
    transform: "matrix(-1 0 0 1 15 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopen);
export default __webpack_public_path__ + "static/media/reopen.66052c11e467a527f486dbf6a0c9f9dd.svg";
export { ForwardRef as ReactComponent };